import { cn } from '@lib/utils';

interface SkeletonProps {
  className?: string;
}

function Skeleton({ className }: SkeletonProps) {
  return (
    <div
      className={cn(
        'h-2.5 w-48 animate-skeleton-shimmer rounded-full bg-[rgba(0,0,0,0.04)]',
        className,
      )}
    />
  );
}

export default Skeleton;
